<script>
    export default {

        name: 'TwitchStream',

        data() {
            return {
                twitchEmbed: {},
                isOnline: false
            };
        },

        props: {
            channel: {
                default: 'offcenternl',
                type: String
            },
            parent: {
                default: () => {
                    return ["offcenter.nl", "offcenter.test"]
                },
                type: [String, Array]
            },
        },

        mounted() {
            this.init()
        },

        methods: {
            init() {
                const elem = this.$refs.stream;
                this.twitchEmbed = new Twitch.Embed(elem, {
                    width: "100%",
                    height: 720,
                    channel: this.channel,
                    // only needed if your site is also embedded on embed.example.com and othersite.example.com
                    parent: this.parent
                });

                this.twitchEmbed.addEventListener(Twitch.Embed.OFFLINE, () => {
                    this.setOffline()
                    console.log("offline")
                });

                this.twitchEmbed.addEventListener(Twitch.Embed.ONLINE, () => {
                    this.setOnline()
                    console.log("online")
                });
            },

            setOffline() {
                this.isOnline = false;
            },

            setOnline() {
                this.isOnline = true;
            },
        }
    };
</script>
